export interface BackofficeUser {
  id: string;
  nome: string;
  email: string;
  role: 'admin' | 'suporte' | 'financeiro' | 'operador';
  ativo: boolean;
  avatar?: string;
}

export const backofficeUsers: BackofficeUser[] = [
  {
    id: 'adm-001',
    nome: 'Administrador Geral',
    email: 'admin@getpoints.com.br',
    role: 'admin',
    ativo: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20confident%20young%20man%20in%20business%20casual%20attire%20neutral%20background%20studio%20lighting&width=100&height=100&seq=1&orientation=squarish'
  },
  {
    id: 'sup-001',
    nome: 'Ana Souza',
    email: 'suporte@getpoints.com.br',
    role: 'suporte',
    ativo: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20friendly%20young%20woman%20with%20warm%20smile%20business%20casual%20attire%20neutral%20background%20studio%20lighting&width=100&height=100&seq=2&orientation=squarish'
  },
  {
    id: 'fin-001',
    nome: 'Carlos Mendes',
    email: 'financeiro@getpoints.com.br',
    role: 'financeiro',
    ativo: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20mature%20man%20in%20formal%20business%20attire%20glasses%20neutral%20background%20studio%20lighting&width=100&height=100&seq=3&orientation=squarish'
  },
  {
    id: 'op-001',
    nome: 'Mariana Lima',
    email: 'operador@getpoints.com.br',
    role: 'operador',
    ativo: true,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20curly%20hair%20business%20casual%20attire%20neutral%20background%20studio%20lighting&width=100&height=100&seq=4&orientation=squarish'
  }
];

export const getBackofficeUserByEmail = (email: string): BackofficeUser | undefined => {
  return backofficeUsers.find(u => u.email === email);
};

export const getDefaultPasswordForRole = (): string => {
  return '123456';
};